import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync } from '../../core/ComponentSync.js';
import { resolveContent } from '@nu-art/ts-common';
import { ModuleFE_SyncManager } from '../../modules/sync-manager/ModuleFE_SyncManager.js';
import './AwaitSync.scss';
export class AwaitSync extends ComponentSync {
    __onPermissibleModulesUpdated = () => this.reDeriveState();
    shouldComponentUpdate() {
        return true;
    }
    deriveStateFromProps(nextProps, state) {
        // Wait until we've received the list of modules the user has permission to see. Until we have them, we wait.
        state.awaiting = ModuleFE_SyncManager.getPermissibleModuleNames().length === 0;
        return state;
    }
    render() {
        if (!this.state.awaiting)
            return this.props.children;
        if (this.props.customLoader)
            return resolveContent(this.props.customLoader);
        return _jsx("div", { className: 'ts-await-sync-loader', onClick: () => {
                this.logInfo('Awaiting Sync');
            } });
    }
}
//# sourceMappingURL=AwaitSync.js.map